<template>
    <pre style="padding: 20px">
        {{versionInfo}}
    </pre>
</template>

<script>
    export default {
        data() {
            return {
                versionInfo: GIT_DESCRIBE || {}
            }
        },
    }
</script>
